import { useAppDispatch, useAppSelector } from '../store/hooks';
import { selectSelectedServer } from '../store/servers/serversSelector';
import { useCallback } from 'react';
import { setSelectedServerName } from '../store/servers/serversActions';
import { ServerModel } from '../models/serverModel';

export const useSelectedServer = (): [
  ServerModel | undefined,
  (server: ServerModel) => void,
] => {
  const dispatch = useAppDispatch();
  const selectedServer = useAppSelector(selectSelectedServer);

  const setSelectedServer = useCallback((server: ServerModel) => {
    dispatch(setSelectedServerName(server.displayName));
  }, [dispatch]);

  return [
    selectedServer,
    setSelectedServer,
  ];
};